import { AfterViewInit, Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';

import { SOURCE_MAPPINGS } from '../models/source.model';
import { LinkifyPipe } from '../linkify/linkify.pipe';


@Component({
  selector: 'app-data-item',
  templateUrl: './data-item.component.html',
  styleUrls: ['./data-item.component.scss']
})
export class DataItemComponent implements AfterViewInit {
  @Input() source: number;
  @Input() compact = false;
  @Input() showLabel = false;
  @Input() linkify = false;
  @Input() flex = false;

  @ViewChild('wrapper') content: ElementRef;

  @HostBinding('class.data-item') private _cls = true;
  @HostBinding('class.data-item--compact') private get _clsCompact(): boolean {
    return this.compact;
  }

  constructor(private _linkifyPipe: LinkifyPipe) {}

  get sourceValid(): boolean {
    return SOURCE_MAPPINGS.has(this.source);
  }

  ngAfterViewInit() {
    if (this.linkify) {
      const el = this.content.nativeElement;
      el.innerHTML = this._linkifyPipe.transform(el.innerHTML);
    }
  }
}
